module.exports = __webpack_public_path__ + "static/img/shybk.2346bdc1.png";